import { tariff } from '../paths';
import { getValue } from '../selectors';
export var getDraftTariff = function (state) { return getValue(tariff, state); };
